import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoutes';
import Layout from './layout';
import Auth from './pages/auth/Auth';
import Login from './pages/auth/Login';
import ForgetPassword from './pages/auth/ForgotPassword';
import SSORedirectHandler from './pages/auth/SSORedirectHandler';
import LogOutAlert from './pages/auth/LogOutAlert';
import NotFoundPage from './pages/admin/NotFound/NotFoundPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { checkAndRefreshToken, initializeUserState } from './commonUtils/authUtils';

function App() {
  const { filteredMenuItems, filteredPrivatePages } = useSelector((state) => state.Auth);

  useEffect(() => {
    initializeUserState();
    checkAndRefreshToken();
    // setupUserActivityListeners();
  }, []);

  const allFilteredRoutes = useMemo(() => {
    return [...(filteredMenuItems || []), ...(filteredPrivatePages || [])];
  }, [filteredMenuItems, filteredPrivatePages]);

  const renderRoutes = (menuItems) => {
    return menuItems.flatMap(({ name, heading="", component, to, children }, index) => {
      if (children) {
        return [
          ...renderRoutes(children), // Recursively process deeper levels
          <Route
            key={index}
            path={to}
            element={<Layout selectionName={heading || name} component={component} />}
          />,
        ];
      }
      return (
        <Route
          key={index}
          path={to}
          element={<Layout selectionName={heading || name} component={component} />}
        />
      );
    });
  };
  
  return (
    <>
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Routes>
          <Route path="/" element={<Auth component={<Login />} />} />
          <Route path="/sso/callback" element={<SSORedirectHandler />} />
          <Route path="/forgot-password" element={<Auth component={<ForgetPassword />} />} />
          <Route element={<ProtectedRoutes />}>
            {renderRoutes(allFilteredRoutes)}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
      <LogOutAlert />
      <ToastContainer />
    </>
  );
}

export default App;
